import { post } from "./Request";

export async function exportProject(token: string, id: string): Promise<void> {
  await post(`export/project/${id}`, token);
}
